import { render } from "./ChatMessage.vue?vue&type=template&id=df1ca5f4&bindings={}"
import script from "./ChatMessage.vue?vue&type=script&lang=ts"
export * from "./ChatMessage.vue?vue&type=script&lang=ts"

import "./ChatMessage.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script